import { __awaiter } from "tslib";
/*
 * @Author: wuyanbin beijingwyb@163.com
 * @Date: 2019-12-20 11:22:39
 * @Last Modified by: wuyanbin beijingwyb@163.com
 * @Last Modified time: 2019-12-20 20:01:21
 */
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { notification } from 'antd';
import mapping from '@/shared/mapping';
const isOpenBidConfirmMapping = mapping.setRuleKeyVal.isOpenBidConfirm.value;
const initData = {
    isEditAble: false,
    isInit: false,
};
const configData = {
    isOpenBidConfirmVal: '0',
};
export default createStore({
    state: Object.assign(Object.assign({}, initData), configData),
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
    },
    effects: {
        // 切换编辑状态
        toggleIsEditAble(payload, { state, update }) {
            update({ isEditAble: !state.isEditAble });
        },
        // 取消
        cancel(payload, { state, rootState }) {
            this.getRuleData({});
        },
        handleChange(payload, { state, update }) {
            this.SET_STATE({
                [payload.type]: payload.value,
            });
        },
        // 查询规则
        getRuleData(payload, { state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const reqData = [{
                        "typeId": isOpenBidConfirmMapping,
                        "keyName": rootState.userInfo.user.tenantCode,
                        "enableCache": true
                    }];
                yield Api.base.getKeyValueListByQueries({ keyValueQueries: JSON.stringify(reqData) }).then((res) => {
                    if (res) {
                        this.SET_STATE({
                            isInit: !(res && res.length > 0),
                            isOpenBidConfirmVal: (res && res.length > 0) ? res[0].value : '0',
                            isEditAble: false
                        });
                    }
                });
            });
        },
        // 保存
        save(payload, { state, rootState, update }) {
            const ruleData = {
                typeId: isOpenBidConfirmMapping,
                keyName: rootState.userInfo.user.tenantCode,
                value: state.isOpenBidConfirmVal,
            };
            const saveUrl = state.isInit ? 'setKeyValueOperate' : 'updateKeyValueOperate';
            Api.base[saveUrl](ruleData).then((res) => {
                if (res) {
                    this.SET_STATE({ isEditAble: false });
                    notification.success({ message: '保存成功' });
                }
                else {
                    notification.error({ message: '保存失败,请稍后重试' });
                }
            });
        },
    }
});
